/**
 * Kendo UI Chat Widget
 *
 * This file serves as the entry point for the Chat widget.
 */
import "./kendo.core.js"; // Still required for the time being, because we need to access the global kendo object.
import { Chat } from "./chat";
import { utilsService, widgetRegistryService } from "./core";

export const __meta__ = {
    id: "chat",
    name: "Chat",
    category: "web",
    description: "The Chat component.",
    depends: ["data", "draganddrop", "html.button", "textarea", "menu", "avatar", "toolbar", "speechtotextbutton"]
};

// Keep the chat namespace for backwards compatibility
window.kendo.chat = {};
$.extend(window.kendo.chat, {
    ChatView: {},
    Component: {},
    Components: {},
    Templates: {},
    getTemplate: () => utilsService.logToConsole("The getTemplate method is deprecated. Use one of the built-in templates or append elements manually.", "warn"),
    getComponent: () => utilsService.logToConsole("The getComponent method is deprecated. Use one of the built-in templates or append elements manually.", "warn"),
    registerTemplate: () => utilsService.logToConsole("The registerTemplate method is deprecated. Use one of the built-in templates or append elements manually.", "warn"),
    registerComponent: () => utilsService.logToConsole("The registerComponent method is deprecated. Use one of the built-in templates or append elements manually.", "warn")
});

// Register the widget
widgetRegistryService.register(Chat);

// Re-export for consumers
export { Chat };

export default kendo;